import { Injectable } from '@angular/core';
import { Observable, Subject, filter, map } from 'rxjs';
import { isRefreshResource } from './agent-catalog';

/**
 * "Something the agent changed is shown here — reload it."
 *
 * Every write capability names the lists it touches (`refresh=` in its
 * @capability spec). After the write the agent bridge calls `emit()`, and each
 * page that shows one of those lists reloads with its own filters:
 *
 *   this.agentRefresh.on('buckets').pipe(takeUntil(this.destroy$))
 *     .subscribe(() => this.bucketService.listBuckets());
 *
 * check-agent-contracts.mjs fails when a resource some capability refreshes
 * has no listener anywhere.
 */
@Injectable({ providedIn: 'root' })
export class AgentRefreshService {
  private readonly bus = new Subject<string>();

  on(resource: string): Observable<void> {
    return this.bus.pipe(
      filter((r) => r === resource),
      map(() => undefined)
    );
  }

  /** Announces the given resources; unknown names are dropped. Returns those announced. */
  emit(resources: readonly string[]): string[] {
    const known = [...new Set(resources)].filter(isRefreshResource);
    known.forEach((r) => this.bus.next(r));
    return known;
  }
}
